import { useState } from 'react';
import AcepMaster from '../../acep-master';
import PublicCMERequirements from './PublicCMERequirements';
import PublicSSOProvider from './PublicSSOProvider';

const PublicCMERequirementsPage = () => {
  const [isAcepMasterLoaded, setAcepMasterLoaded] = useState(false);

  return (
    <PublicSSOProvider>
      <AcepMaster onAcepMasterLoad={() => setAcepMasterLoaded(true)}>
        {isAcepMasterLoaded ? <PublicCMERequirements /> : null}
      </AcepMaster>
    </PublicSSOProvider>
  );
};

export default PublicCMERequirementsPage;
